'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 框架定义的常量
 * 
 * @export
 * @class Constants
 */
var Constants = function Constants() {
  (0, _classCallCheck3.default)(this, Constants);
}; /* eslint-disable */


Constants.minimaConfigFileFullPath = _path2.default.resolve('./minima.json');
Constants.defaultVersion = '0.0.0';
Constants.defaultPluginState = 'active';
Constants.defaultPluginsDirectory = 'plugins';
Constants.installedPluginState = 'installed';
Constants.defaultStartLevel = 50;
Constants.defaultFrameworkStartLevel = 100;
Constants.pluginConfigFileName = 'plugin.json';
Constants.defaultActivator = 'Activator.js';
exports.default = Constants;
//# sourceMappingURL=Constants.js.map